/**
 * How long the app waits before retrying on its own, by how many quiet retries came before:
 * 10 s, 20 s, 40 s, 80 s, then every 2 minutes. While the offline screen is up, this is what
 * takes it away once the connection is back, without anyone pressing "Try again". Before,
 * nothing retried until the person did, and a line that had dropped for a moment left the
 * screen up, across restarts, long after it came back.
 */
export function retryDelayMs(retriesSoFar: number): number {
  return Math.min(10_000 * 2 ** retriesSoFar, 120_000);
}
